import { ArrowUp, Phone } from "lucide-react";
import { Logo } from "./Logo";

const NAV = [
    { label: "Work", href: "#work" },
    { label: "Services", href: "#services" },
    { label: "About", href: "#about" },
    { label: "Packages", href: "#packages" },
    { label: "Gallery", href: "#gallery" },
    { label: "Contact", href: "#contact" },
];

export const Footer = () => (
    <footer
        data-testid="site-footer"
        className="bg-[#0C0C0C] text-[#F1F1EF] px-5 sm:px-8 lg:px-12 pt-16 md:pt-24 pb-10 mt-6 rounded-t-[2.5rem] border-t border-[#F1F1EF]/10"
    >
        <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 pb-12 border-b border-[#F1F1EF]/10">
                <div>
                    <Logo />
                    <p className="mt-5 max-w-sm font-serif-ed italic text-2xl md:text-3xl leading-snug text-[#D3A0A7]">
                        Same business. Bigger impact. ♡
                    </p>
                </div>
                <nav className="flex flex-wrap gap-x-8 gap-y-3">
                    {NAV.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`footer-link-${l.label.toLowerCase()}`}
                            className="link-underline text-sm font-medium text-[#A9A6A0] hover:text-[#F1F1EF] transition-colors duration-300"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
            </div>

            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pt-10">
                <div className="flex flex-wrap items-center gap-4">
                    <a
                        href="mailto:savvmedia.info@gmail.com"
                        data-testid="footer-email-link"
                        className="link-underline text-sm font-semibold text-[#F1F1EF]"
                    >
                        savvmedia.info@gmail.com
                    </a>
                    <span className="w-1 h-1 rounded-full bg-[#C9DDEE]" />
                    <a
                        href="tel:+14175904345"
                        data-testid="footer-phone-link"
                        className="inline-flex items-center gap-2 link-underline text-sm font-semibold text-[#F1F1EF]"
                    >
                        <Phone size={14} />
                        (417) 590-4345
                    </a>
                    <span className="w-1 h-1 rounded-full bg-[#C9DDEE]" />
                    <span
                        data-testid="footer-socials-note"
                        className="font-hand text-xl text-[#C9DDEE] rotate-[-1deg]"
                    >
                        instagram · tiktok · facebook — coming soon ♡
                    </span>
                </div>
                <div className="flex items-center gap-6">
                    <p className="text-xs text-[#A9A6A0]/60">
                        © 2026 Savv Media. All rights reserved.
                    </p>
                    <a
                        href="#top"
                        data-testid="footer-back-to-top"
                        aria-label="Back to top"
                        className="w-10 h-10 rounded-full border border-[#F1F1EF]/20 flex items-center justify-center text-[#F1F1EF] hover:bg-[#C9DDEE] hover:border-[#C9DDEE] hover:text-[#0C0C0C] transition-colors duration-300"
                    >
                        <ArrowUp size={16} />
                    </a>
                </div>
            </div>
        </div>
    </footer>
);
